<template>
  <div
    class="app-splash"
    :class="isDark ? 'app-splash--dark' : 'app-splash--light'"
    role="status"
    aria-live="polite"
    :aria-label="$t('Loading') || 'Loading'"
  >
    <div class="app-splash__logo-wrap">
      <img
        :src="logoSrc"
        alt="LeSIM"
        class="app-splash__logo"
        width="220"
        height="116"
        decoding="async"
      >
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { resolveIsDark, themeMode } from '@/utils/theme'

const isDark = computed(() => {
  themeMode.value
  return resolveIsDark()
})

const logoSrc = computed(() => (
  isDark.value ? '/og-image.png' : '/splash-logo-light.png'
))
</script>

<style scoped>
.app-splash {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top, 0px)) 24px max(16px, env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  transition: background-color 0.2s ease;
}

.app-splash--light {
  background: #f8f7fb;
}

.app-splash--dark {
  background: #000000;
}

.app-splash__logo-wrap {
  width: min(72vw, 220px);
  animation:
    app-splash-logo-in 0.42s cubic-bezier(0.22, 1, 0.36, 1) both,
    app-splash-logo-pulse 1.25s ease-in-out 0.42s infinite;
}

.app-splash__logo {
  display: block;
  width: 100%;
  height: auto;
}

@keyframes app-splash-logo-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes app-splash-logo-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.88;
    transform: scale(1.035);
  }
}
</style>
